export default class Transaction {
  Id;
  Source;
  CreatedDate;
  CreatedUser;
  DeviceId;
  ExternalId;
  DeviceParameterTransactionValues;
  TransactionValuesMessages;
  Color;
  TransactionSource;
  Status;
  ErrorMessages;
}

export class DeviceParameterTransactionValues {
  Id;
  DeviceParameterTransactionId;
  ParameterName;
  OldValue;
  NewValue;
}
